import React from 'react';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from 'src/config/msal.config';
import LinkIcon from '@mui/icons-material/Link';
import config from 'src/config';
import Swal from 'sweetalert2';
import { connectService } from 'src/services/service.service';
import axios from 'axios';
import { getToken } from 'src/services/auth.service';

// ----------------------------------------------------------------------


class OnedriveConnect extends React.Component {
  
  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    let query = window.location.search;
		
		const query_params = new URLSearchParams(query);
		let query_params_obj = Object.fromEntries(query_params.entries());

    if ('code' in query_params_obj) {


      let exchange_payload = {
        client_id: process.env.REACT_APP_ONEDRIVE_CLIENT_ID,
        grant_type: 'authorization_code',
        code: query_params_obj['code'],
        redirect_uri: process.env.REACT_APP_ONEDRIVE_CALLBACK_URL,
        code_verifier: localStorage.getItem('onedrive_pkce_code_verifier')
      }

      // Get access token & refresh token
      let access_token_res = await axios.post('https://login.microsoftonline.com/common/oauth2/v2.0/token', exchange_payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });

      if (access_token_res.data.error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: access_token_res.data.error_description,
          confirmButtonText: 'Ok',
          confirmButtonColor: config.primaryColor
        });
        return;
      }
      
      this.onedriveOAuthCallbackHandler({ ...access_token_res.data, redirect_uri: process.env.REACT_APP_ONEDRIVE_CALLBACK_URL });
      // remove query params from url
      window.history.replaceState({}, document.title, window.location.pathname);
      localStorage.removeItem('onedrive_pkce_code_verifier');
      localStorage.removeItem('onedrive_pkce_code_challenge');
		}

    

  }

  async onedriveOAuthCallbackHandler(payload) {
    // Show swal saying connecting Miro...
    Swal.fire({
      title: 'Connecting Onedrive...',
      text: 'Please wait while we connect your Onedrive account.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    let response = await connectService(config.SERVICES.ONEDRIVE, payload);

    Swal.close();

    if (response.error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: response.error,
        confirmButtonText: 'Ok',
        confirmButtonColor: config.primaryColor
      });
      return;
    }

    Swal.fire({
      icon: 'success',
      title: 'Onedrive Connected',
      text: 'Your Onedrive account has been connected successfully.',
      confirmButtonText: 'Ok',
      confirmButtonColor: config.primaryColor
    }).then(() => {
      // reload page
      window.location.reload();
    });

  }

  connectOnedrive = async () => {
    let url = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${process.env.REACT_APP_ONEDRIVE_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(process.env.REACT_APP_ONEDRIVE_CALLBACK_URL)}&response_mode=query&scope=${encodeURIComponent(loginRequest.scopes.join(' '))}&prompt=select_account&state=${JSON.stringify({ token: getToken() })}`;
    window.location.href = url;
  }

  render() {

      return (
        <>
          <IconButton aria-label="connected"
            onClick={this.connectOnedrive}
          >
            <LinkIcon
              fontSize='small'
            />
          </IconButton>
        </>
      )
  }
}

export default function (props) {
    const navigate = useNavigate();
    return <OnedriveConnect {...props} navigate={navigate} />;
}
